import React from 'react';
import { Link } from 'react-router-dom';
import './PrivacyPolicy.css';

function PrivacyPolicy() {
  return (
    <div className="privacy-policy-page">
      <div className="container">
        <div className="privacy-content">
          <h1>Privacy Policy</h1>
          
          <div className="privacy-section">
            <h2>Who We Are</h2>
            <p>
              We are Jobsopportunity, an online platform that provides Our website provides valuable
              career-related content, including Blog job listings, internship opportunities, walk-in
              interviews, and blog articles to help individuals find the right opportunities and stay informed
              about career trends.Our mission is to deliver valuable content while protecting the privacy and
              security of our visitors.
            </p>
          </div>

          <div className="privacy-section">
            <h2>Information We Collect</h2>
            <p>
              We may collect the following types of information when you visit or interact with our website:
            </p>
            <p><strong>Personal Data:</strong> Name, email address, or other details you voluntarily provide (e.g., via
            contact forms, comments, or newsletter sign-ups).</p>
            <p><strong>Non-Personal Data:</strong> Browser type, device type, IP address, operating system, and
            browsing behavior collected through cookies and analytics tools.</p>
            <p><strong>User-Generated Content:</strong> Information you provide in comments, uploads, or form
            submissions.</p>
          </div>

          <div className="privacy-section">
            <h2>How We Use Your Information</h2>
            <p>We use the information we collect to:</p>
            <ul>
              <li>Provide, operate, and improve our website.</li>
              <li>Personalize your user experience.</li>
              <li>Respond to comments, questions, or inquiries.</li>
              <li>Send newsletters, promotional offers, or updates (if you subscribe).</li>
              <li><strong>User improvement experience:</strong> to analyze how visitors interact with our website, identify
              trends, and improve material and navigation.</li>
              <li><strong>Communication:</strong> To respond to user inquiries, provide customer support, and send important
              updates about our website..</li>
              <li><strong>Job-related services</strong> provide information about job alerts, opportunities, and relevant careers
              based on their interests.</li>
              <li><strong>Analytics and Research:</strong> User behavior, website traffic measurement, and increasing
              marketing strategies.</li>
              <li><strong>Legal compliance:</strong> to follow the applicable laws, regulations, and apply our terms and policies.</li>
            </ul>
            <p>We will never use your personal information for any illegal purpose.</p>
          </div>

          <div className="privacy-section">
            <h2>Third-Party Services</h2>
            <p>
              We may use third-party companies and service providers to operate, analyze, and improve our
              website, as well as to display advertisements. These third-party services (such as Google
              AdSense, Google Analytics, and other advertising or analytics partners) may collect information
              about your browsing behavior through cookies, tracking technologies, or similar tools in order to
              provide relevant ads and measure performance.
            </p>
            <p>
              Please note that we do not control how third-party providers collect, use, or protect your
              information. Their practices are governed by their own privacy policies, and we encourage you
              to review those policies for a better understanding of how your data may be handled. By using
              our website, you acknowledge that such third-party services may process your data in
              accordance with their policies and applicable laws.
            </p>
          </div>

          <div className="privacy-section">
            <h2>Comments</h2>
            <p>
              When visitors leave comments on our site, we collect the data shown in the comments form, the
              visitor's IP address, and browser user agent string to help detect spam.
            </p>
          </div>

          <div className="privacy-section">
            <h2>Cookies</h2>
            <p>
              Our website uses cookies to enhance your browsing experience, analyze site traffic, and deliver
              personalized advertisements through services such as Google AdSense. Cookies are small text
              files stored on your device that help us remember your preferences, improve website
              functionality, and measure how visitors interact with our content. Some cookies are essential for
              the website to function properly, while others are used for analytics and advertising purposes.
            </p>
            <p>
              You can choose to disable or delete cookies through your browser settings; however, please
              note that doing so may affect certain features and performance of the site. By continuing to use
              our website, you consent to our use of cookies in accordance with this Privacy Policy.
            </p>
          </div>

          <div className="privacy-section">
            <h2>Third-party content</h2>
            <p>
              Articles on our website may contain integrated content such as videos, images, or articles from
              external sources. When you interact with this content, it functions in the same way as if you
              were visiting the external website directly. These third-party websites may collect information
              about you, use cookies, and track your interactions with the integrated content in accordance
              with their own privacy policies.
            </p>
          </div>

          <div className="privacy-section">
            <h2>Remove Location Data from Uploaded Images</h2>
            <p>
              When uploading images on a website, it is important to ensure that they do not include
              embedded location data EXIF, GPS). This data, if left in the file, can be extracted by visitors who
              download the images, probably revealing the details of the sensitive space. To maintain privacy
              and security, always remove or disable the location information before sharing online. This helps
              in protecting both the personal information of precautionary uploaders and the overall protection
              of users of the website.
            </p>
          </div>

          <div className="privacy-section">
            <h2>What Rights You Have Over Your Data</h2>
            <p>
              Depending on your location, you may have the following rights under GDPR, CCPA, or other
              data protection laws:
            </p>
            <ul>
              <li>The right to access, update, or delete your personal data.</li>
              <li>The right to object to or restrict processing of your data.</li>
              <li>The right to withdraw consent at any time.</li>
              <li>The right to data portability.</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h2>Data Protection and Security</h2>
            <p>
              We take appropriate technical and organizational measures to safeguard your personal
              information against unauthorized access, alteration, disclosure, or destruction. However, no
              method of transmission over the Internet is completely secure.
            </p>
          </div>

          <div className="privacy-section">
            <h2>Children's privacy</h2>
            <p>
              The job opportunity is not directed for children under 13 years of age. We do not deliberately
              collect personal information from children. If we find out that we have unknowingly collected
              such information, we will remove it immediately.
            </p>
          </div>

          <div className="privacy-section">
            <h2>Where Your Data is Sent:</h2>
            <p>
              When someone leaves a comment, it might be automatically scanned by a system that looks for
              spam before it gets posted.
            </p>
          </div>

          <div className="privacy-section">
            <h2>Linking to social platforms:</h2>
            <p>
              If you use social media (like Facebook) to sign up, log in, or interact with our services (such as
              clicking a "like" button), we can get some of your info from that social media account — like your
              name, email, photo, and friend list — depending on the settings you've chosen on that platform.
              We may keep and use that info as explained in our Privacy Policy. If you don't want this to
              happen, you should check and change your privacy settings on that social media site before
              using our services.
            </p>
          </div>

          <div className="privacy-section">
            <h2>Data storage and safety</h2>
            <p><strong>Data Protection</strong></p>
            <p>
              We use suitable administrative, technical, and physical security measures to protect your
              personal information from unauthorized access, misuse, loss, or disclosure.
            </p>
            <p><strong>Data retention</strong></p>
            <p>
              We maintain personal information until then in this policy or to fulfill the objectives mentioned by
              the law only. Non-individual data can be retained indefinitely for research and analysis.
            </p>
          </div>

          <div className="privacy-section">
            <h2>User rights</h2>
            <ul>
              <li><strong>Access and Review:</strong> You can request access to personal data you have.</li>
              <li><strong>Improvement and update:</strong> You can request improvement for wrong or incomplete data.</li>
              <li><strong>Determination:</strong> You can request to remove your personal data, subject to legal or creative
              obligations.</li>
              <li><strong>Data Portability:</strong> If applicable, you can request a copy of your personal information in a
              structured, electronic format.</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h2>Contact information</h2>
            <p>
              If you have any questions,or requests about this privacy policy, please contact us:
            </p>
            <p><strong>Job opportunities</strong></p>
            <p>Website: https://www.jobsoportunity.in/</p>
            <p>Email: jobsopportunityin@gmail.com</p>
            <p>Phone: 9380867233</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy; 